// eslint-disable-next-line no-restricted-imports
import { FinancialMonitoringFragment } from 'api/generated/graphql';
import {
  AmlPolicyReviewFrequency,
  LegalClientFinancialMonitoringEntity,
  MonetaryServiceTransactionCountForLastSixMonths,
} from 'api/types/entity';
import { Maybe } from 'types/maybe';

import { parseGlobalFinancialMonitoringEntity } from './parseGlobalFinancialMonitoringEntity';

export const parseFinancialMonitoringEntity = (
  data?: Maybe<FinancialMonitoringFragment>
): LegalClientFinancialMonitoringEntity | undefined =>
  data
    ? {
        isSubjectToRegulation: data.isSubjectToRegulation,
        financeInfo: data.financeInfo
          ? {
              ...data.financeInfo,
              amlPolicyReviewFrequency:
                AmlPolicyReviewFrequency[
                  data.financeInfo.amlPolicyReviewFrequency
                ],
              monetaryServiceTransactionCountForLastSixMonths:
                MonetaryServiceTransactionCountForLastSixMonths[
                  data.financeInfo
                    .monetaryServiceTransactionCountForLastSixMonths
                ],
              dateOfLastCheck: data.financeInfo.dateOfLastCheck
                ? new Date(data.financeInfo.dateOfLastCheck)
                : undefined,
            }
          : undefined,

        globalInfo: parseGlobalFinancialMonitoringEntity(data.globalInfo),
      }
    : undefined;
